import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, MenuItem, Select, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const CrmModal = props => {
  const [finalList, setFinalList] = useState([]);
  const [value, setValue] = useState();
  const [finalFeeds, setFinalFeeds] = useState(['null']);
  let feedBacks = [
    'NEW',
    'OPEN',
    'WAITING',
    'BOOKED',
    'CANCELLED_RENTER',
    'CANCELLED_MANAGER',
    'NO_SHOW',
    'VISITED',
    'APPLIED_LOST',
    'IN_REVIEW',
    'APPLIED_LEASED',
    'LOST'
  ];

  const array2 = [
    {
      stage: 'Inbound',
      thirdPartyStatuses: ['NEW'],
      overrideZumaStatus: false
    },
    {
      stage: 'Contacted',
      thirdPartyStatuses: ['OPEN', 'WAITING'],
      overrideZumaStatus: false
    },
    {
      stage: 'Tour Scheduled',
      thirdPartyStatuses: ['BOOKED'],
      overrideZumaStatus: false
    },
    {
      stage: 'Tour Cancelled',
      thirdPartyStatuses: ['CANCELLED_MANAGER', 'CANCELLED_RENTER'],
      overrideZumaStatus: false
    },
    {
      stage: 'No Show',
      thirdPartyStatuses: ['NO_SHOW'],
      overrideZumaStatus: false
    },
    {
      stage: 'Tour Completed',
      thirdPartyStatuses: ['VISITED'],
      overrideZumaStatus: false
    },
    {
      stage: 'Applied',
      thirdPartyStatuses: ['APPLIED_LOST', 'IN_REVIEW', 'APPLIED_LEASED'],
      overrideZumaStatus: false
    },
    {
      stage: 'Lost',
      thirdPartyStatuses: ['LOST'],
      overrideZumaStatus: false
    },
    {
      stage: 'Ignore Status Change',
      thirdPartyStatuses: [],
      overrideZumaStatus: false
    }
  ];

  useEffect(() => {
    if (props?.tenantData?.statusMappings?.mappings) {
      let array1 = props?.tenantData?.statusMappings?.mappings;
      for (let i = array2?.length - 1; i >= 0; i--) {
        for (let j = 0; j < array1?.length; j++) {
          if (array2[i] && array2[i].stage === array1[j].stage) {
            array2.splice(i, 1);
          }
        }
      }

      let list = array1?.concat(array2);
      setFinalList(list);
      props.setCrmData(list);
    } else {
      setFinalList(array2);
      props.setCrmData(array2);
    }
  }, []);

  useEffect(() => {
    let forDeletion = [];
    finalList?.forEach(x => {
      x.thirdPartyStatuses.length > 0 &&
        x.thirdPartyStatuses.forEach(y => forDeletion.push(y));
    });
    forDeletion = forDeletion.filter(function (item, pos) {
      return forDeletion.indexOf(item) == pos;
    });
    let arr = feedBacks;
    let difference = arr?.filter(x => !forDeletion.includes(x));

    setFinalFeeds(difference);
  }, [props]);

  const handleCheck = (e, x) => {
    finalList.map(y => {
      if (y.stage === x.stage) {
        y.overrideZumaStatus = e;
      }
    });
    setFinalList(finalList);
    props.setCrmData(finalList);
  };

  const deleteStatus = (y, x, i, e) => {
    let updated = finalList?.map((y, index) => {
      let value = y?.thirdPartyStatuses[i];
      if (y.stage == x?.stage) {
        let arr = y?.thirdPartyStatuses?.filter(item => item != value);
        return { ...y, thirdPartyStatuses: arr };
      }
      return y;
    });
    setFinalList([...updated]);
    props.setCrmData([...updated]);
  };

  const handleMappings = (e, x, index, y) => {
    const check = x.thirdPartyStatuses.includes('');

    if (check === true) {
      const newArr = x?.thirdPartyStatuses?.map(element => {
        if (element === '') {
          return e.target.value;
        }
        return element;
      });
      finalList.map((y, index) => {
        if (y?.stage == x?.stage) {
          y.thirdPartyStatuses = [...newArr];
        }
      });
    }
    if (check === false) {
      const newArr = x?.thirdPartyStatuses?.map((element, i) => {
        if (index === i) {
          return e.target.value;
        }
        return element;
      });
      finalList.map((y, index) => {
        if (y?.stage == x?.stage) {
          y.thirdPartyStatuses = [...newArr];
        }
      });
    }
    let rtr = finalFeeds.filter(function (item) {
      return item !== e.target.value;
    });
    setFinalFeeds(rtr);
    setFinalList(finalList);
    props.setCrmData(finalList);
  };

  const handleAdd = (e, x) => {
    const latestdata = finalList.map((y, index) => {
      if (y?.stage == x?.stage) {
        return { ...y, thirdPartyStatuses: [...y.thirdPartyStatuses, ''] };
      }
      return y;
    });

    setFinalList([...latestdata]);
    props.setCrmData([...latestdata]);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {finalList?.map((x, i) => (
        <Box
          key={x.stage}
          sx={{
            bgcolor: theme =>
              theme.palette.mode === 'dark'
                ? theme.palette.background.default
                : theme.palette.grey[50],
            borderRadius: 1,
            px: 1.5,
            py: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, minWidth: 140, flexShrink: 0 }}
          >
            {x?.stage}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 0.5,
              flex: 1
            }}
          >
            {x?.thirdPartyStatuses.map((y, index) =>
              y ? (
                <Chip
                  key={`${x.stage}-${index}`}
                  label={y}
                  size="small"
                  onDelete={() => deleteStatus(y, x, index, value)}
                />
              ) : (
                <Select
                  key={`${x.stage}-${index}`}
                  displayEmpty
                  size="small"
                  value=""
                  onChange={e => handleMappings(e, x, index, y)}
                  sx={{ minWidth: 140 }}
                  renderValue={() => (
                    <Typography variant="body2" color="text.secondary">
                      Select status
                    </Typography>
                  )}
                >
                  {finalFeeds?.map(f => (
                    <MenuItem key={f} value={f}>
                      {f}
                    </MenuItem>
                  ))}
                </Select>
              )
            )}
            <Button
              size="small"
              startIcon={<AddIcon />}
              onClick={e => handleAdd(e, x)}
            >
              Add
            </Button>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CrmModal;
